<template>
  <div id="app">
    <nprogress-container></nprogress-container>
    <vue-confirm-dialog></vue-confirm-dialog>
    <RouterView />
  </div>
</template>
<style lang="scss">
#nprogress .bar {
  background: #d4614f !important;
}
</style>

<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/1.12.1/jquery.min.js"></script>

<script>
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

import NprogressContainer from "vue-nprogress/src/NprogressContainer";
export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  components: {
    NprogressContainer,
  },
  beforeDestroy() {},
  async beforeMount() {
    if (this.account) {
      await this.sync();
      //currentLanguage comes from globalMixin
      this.$i18n.locale = this.currentLanguage;
    }
  },

  computed: {
    ...mapGetters("user", ["account"]),
    favIcon() {
      return this.$store.getters["clientConfig/favIcon"];
    },
  },
  watch: {
    $route(to, from) {},
    favIcon() {
      const link = document.querySelector("link[rel*='icon']");

      if (link && this.favIcon) {
        link.href = this.favIcon;
      }
    },
  },
  methods: {
    ...mapActions("synchronization", ["sync"]),
  },
};
</script>
